"use strict";

define('module/link_in_new_tab',['lib/page_property_miner'], function (ppp) {

  return {
    init: function () {
      if (ppp.matchPage('issues', 'show')) {

        var $descriptionLinks = $('#content').find('.issue .description .wiki a');
        var $noteLinks = $('#content').find('#history .tab-content .journal .wiki a');

        if ($descriptionLinks.size()) {
          // add target attributes to all links in description
          $descriptionLinks.attr('target', '_blank');
        }

        if ($noteLinks.size()) {
          // add target attributes to all links in notes
          $noteLinks.attr('target', '_blank');
        }

      }
    }
  }
});

